/*
 * @Author: ≡Christine 1204356932@qq.com
 * @Date: 2024-10-15 11:25:33
 * @LastEditors: ≡Christine 1204356932@qq.com
 * @LastEditTime: 2024-11-15 10:28:21
 * @FilePath: \management-portal\src\router\helpers\filterMenus.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { t } from '@/hooks/useI18n';
import { RouteRecordRaw } from 'vue-router';

/** 路由过滤成菜单 */
export function filterRoutesToMenus(routes: RouteRecordRaw[], userConfigs: RouteRecordRaw) {
  const menus: App.Menu[] = [];

  routes.forEach((route: RouteRecordRaw) => {
    if (!route.meta || route.meta.isMenu == undefined || route.meta.isMenu) {
      const menuItem: App.Menu = {
        path: route.path,
        title: '',
        icon: ''
      };

      // 获取并设置用户配置菜单数据
      menuItem.title = userConfigs[route.name]?.name || t(route.meta?.title) || '';
      menuItem.icon = userConfigs[route.name]?.icon || route.meta?.icon || ''
      menuItem.sort = userConfigs[route.name]?.sort || route.meta?.sort || 0

      if (route.children && route.children.length > 0) {
        menuItem.children = filterRoutesToMenus(route.children, userConfigs);
      }
      if (!route.meta?.isHide) menus.push(menuItem);
    }
  });
  return menus;
}
